import React from 'react'

import { useTab } from './TabsContext'

const TabsContent = () => {
  const tab = useTab()

  const { Component } = tab || {}
  return !!Component && <Component />
}

export default TabsContent
